import React, { Fragment } from 'react';
import WorkflowPanel from '../component/workflowPanel';
import WorkflowLog from '../component/workflowLog';

function workflowList() {
  return (
    <Fragment>
      <WorkflowPanel />
      <WorkflowLog />
    </Fragment>
  );
}

export default workflowList;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkflowList/container/index.js